import React from 'react';

export type MobileNavIconName =
  | 'home'
  | 'about'
  | 'work'
  | 'services'
  | 'contact'
  | 'linkedin'
  | 'youtube'
  | 'instagram'
  | 'podcast';

interface MobileNavIconProps {
  name: MobileNavIconName;
  className?: string;
}

const iconPaths: Record<
  Exclude<
    MobileNavIconName,
    'linkedin' | 'youtube' | 'instagram' | 'podcast'
  >,
  React.ReactNode
> = {
  home: (
    <>
      <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
      <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </>
  ),
  about: (
    <>
      <path d="M15 10V9" />
      <path d="M16.472 15a6 6 0 01-8.943 0" />
      <path d="M9 10V9" />
      <circle cx="12" cy="12" r="10" />
    </>
  ),
  work: (
    <>
      <path d="M12 12h.01" />
      <path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
      <path d="M22 13a18.15 18.15 0 0 1-20 0" />
      <rect width="20" height="14" x="2" y="6" rx="2" />
    </>
  ),
  services: (
    <>
      <path d="M3 12h18" />
      <path d="M12 3v18" />
      <path d="M17 7 7 17" />
      <path d="m7 7 10 10" />
    </>
  ),
  contact: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" />
    </>
  ),
};

const MobileNavIcon = ({ name, className }: MobileNavIconProps) => {
  if (name === 'linkedin') {
    return (
      <svg
        aria-hidden="true"
        className={className}
        focusable="false"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M6.45 8.3H3.1V19h3.35V8.3ZM4.78 3A1.95 1.95 0 1 0 4.8 6.9 1.95 1.95 0 0 0 4.78 3ZM19.9 12.86c0-3.23-1.72-4.73-4.02-4.73a3.48 3.48 0 0 0-3.16 1.74V8.3H9.38V19h3.34v-5.3c0-1.4.27-2.76 2-2.76 1.7 0 1.72 1.6 1.72 2.85V19h3.34l.12-6.14Z"
        />
      </svg>
    );
  }

  if (name === 'youtube') {
    return (
      <svg
        aria-hidden="true"
        className={className}
        focusable="false"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M21.6 7.2a3 3 0 0 0-2.1-2.12C17.64 4.57 12 4.57 12 4.57s-5.64 0-7.5.5A3 3 0 0 0 2.4 7.2 31.4 31.4 0 0 0 1.9 12c0 1.62.15 3.22.5 4.8a3 3 0 0 0 2.1 2.12c1.86.5 7.5.5 7.5.5s5.64 0 7.5-.5a3 3 0 0 0 2.1-2.12c.35-1.58.5-3.18.5-4.8s-.15-3.22-.5-4.8ZM9.95 15.43V8.57L15.85 12l-5.9 3.43Z"
        />
      </svg>
    );
  }

  if (name === 'instagram') {
    return (
      <svg
        aria-hidden="true"
        className={className}
        fill="none"
        focusable="false"
        stroke="currentColor"
        strokeWidth="1"
        viewBox="0 0 24 24"
      >
        <rect x="3.5" y="3.5" width="17" height="17" rx="4.75" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.35" cy="6.65" r="1" fill="currentColor" stroke="none" />
      </svg>
    );
  }

  if (name === 'podcast') {
    return (
      <svg
        aria-hidden="true"
        className={className}
        fill="none"
        focusable="false"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        viewBox="0 0 24 24"
      >
        <path d="M12 19v3" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <rect x="9" y="2" width="6" height="13" rx="3" />
      </svg>
    );
  }

  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      focusable="false"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
      viewBox="0 0 24 24"
    >
      {iconPaths[name]}
    </svg>
  );
};

export default MobileNavIcon;
